import axios from "axios";
/** 
 * 取得美妝排行榜
 */
export const getRankingDataApi = () => {
  return axios({
    method: "get",
    url: "https://www.pixnet.net/mainpage/api/channel/getStylemeBrands",
    params: {},
    headers: {
      "Content-type": "application/x-www-form-urlencoded;charset=utf-8"
    }
  });
}